<template>
	<div class="reserve-background-width">
		<v-img
			v-if="reservedaysData.mainimg"
			:src="$store.state.frontServer_upload + reservedaysData.mainimg.url"
			@error="imgError()"
			class="imageButton"
		></v-img>
		<v-img v-else-if="reservedaysData.mainimg === null" :src="defaultImg" class="imageButton"> </v-img>

		<v-layout class="pa-4" wrap justify-center>
			<v-flex xs12>
				<btn :btn="nextbtn" :btn_txt="'상담신청'" :style="`color:${$store.state.PointColor8}`" @click="startSurvey"></btn>
			</v-flex>
		</v-layout>
		<!-- <v-layout class="pa-4" wrap justify-center v-else>
			<div>09시10분 부터 방문등록이 가능합니다.</div>
		</v-layout> -->
		<!-- <reserveday-modal :setdialog="reserveDialog" :title="placeTitle" :noInputBox="noInputBox"></reserveday-modal> -->
		<!-- 이름 전화 번호 입력 모달 -->
		<reserveStart :setdialog="startDialog" :reservedaysData="reservedaysData" :nextStep="nextStep"></reserveStart>
		<!-- 드래그 버전 설문 모달 -->
		<reservedayModalWaiting :setdialog="reserveDialog" :title="placeTitle" :reservedaysData="reservedaysData"></reservedayModalWaiting>
		<!-- 슬라이드 버전 설문 모달 -->
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal5, btn, reserveStart, reservedayModalWaiting } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
// txtField, selectBox,
export default {
	components: {
		// txtField,
		// selectBox,
		btn,
		reserveStart,
		reservedayModalWaiting,
		alertModal5,
	},
	metaInfo() {
		return {
			title: this.reservedaysData.title,
		}
	},
	data() {
		return {
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.' },
			numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'] },
			numtxtField: { value: '', outlined: true, placeholder: '나머지 번호를 입력하세요', onlyNumber: true, maxlength: 8 },
			nextbtn: {
				dark: true,
				block: true,
				large: true,
				class: 'customBtn',
				color: '#009EA1',
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				dialog1: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},

			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.', color: this.$store.state.PointColor7 },
				numSel: {
					value: '010',
					outlined: true,
					class: 'selectNum',
					items: ['010', '011', '016', '017'],
					color: this.$store.state.PointColor7,
				},
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '나머지 번호를 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: this.$store.state.PointColor7,
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			reservedaysData: { business: { QRlogo: null } },
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			// noInputBox: false,
			btnDisabled: false,
			nowSurvey: {
				num: 0,
				imgs: [],
			},
			surveyLegnth: 0,
			startBtn: false,
		}
	},
	async created() {
		await this.reservedays()
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		imgError() {
			this.reservedaysData.mainimg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			if (this.$route.name === 'reservedirect') {
				let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
				if (dateIndex !== -1) {
					this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
					this.surveyLegnth--
				}
				let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
				if (timeIndex !== -1) {
					this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
					this.surveyLegnth--
				}
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeCode = res.data.createTrackingCode.trackingCode.code
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.reservedaysData.population || this.reservedaysData.population === '설정 해제') {
						if (this.reservedaysData.accessPhones !== '' && this.reservedaysData.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			await this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.reservedaysData = res.data.reservedays[0]
					if (res.data.reservedays[0].business) {
						if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
						let li = []
						if (res.data.reservedays[0].business.useTerm) {
							li.push(res.data.reservedays[0].business.useTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.privacyTerm_reserveday) {
							li.push(res.data.reservedays[0].business.privacyTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.uniqueTerm) {
							li.push(res.data.reservedays[0].business.uniqueTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.marketingTerm_reserveday) {
							li.push(res.data.reservedays[0].business.marketingTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.adTerm) {
							li.push(res.data.reservedays[0].business.adTerm)
						} else li.push(null)

						this.$store.state.termIdList = li
					}
					// reservedays data 초기화
					// this.$store.state.reservedayData = res.data.reservedays[0]
					this.$store.state.reservedayData = JSON.parse(JSON.stringify(res.data.reservedays[0]))
					if (res.data.reservedays[0].consultingTitle) {
						this.$store.state.reservedayData.title = res.data.reservedays[0].consultingTitle
					}
					if (res.data.reservedays[0].business.color) {
						this.$store.state.PointColor7 = res.data.reservedays[0].business.color
						this.nextbtn.color = res.data.reservedays[0].business.color

						this.startDialog.nametxtField.color = res.data.reservedays[0].business.color
						this.startDialog.numSel.color = res.data.reservedays[0].business.color
						this.startDialog.numtxtField.color = res.data.reservedays[0].business.color
					}
					if (res.data.reservedays[0].business.btnColor) {
						this.$store.state.PointColor8 = res.data.reservedays[0].business.btnColor
					} else {
						this.$store.state.PointColor8 = 'white'
					}
					// tplCode 초기화
					// this.$store.state.reservedayTplCode = this.reservedaysData.tplCode[0]
					// 설문 데이터 value 삽입
					if (res.data.reservedays[0].input_box !== null) {
						this.placeTitle = res.data.reservedays[0].title
						res.data.reservedays[0].input_box.categories.forEach(element => {
							if (element.tag === 'location') {
								if (element.defalutLocation) {
									this.$store.state.searchsel_city1.value = element.defalutLocation.split('_')[0]
									this.loc_firstSelect(element.defalutLocation.split('_')[0])
									if (element.defalutLocation.split('_')[1]) {
										this.loc_twoSelect(element.defalutLocation.split('_')[1])
										this.$store.state.searchsel_city2.value = element.defalutLocation.split('_')[1]
									}
									if (element.defalutLocation.split('_')[2]) {
										this.$store.state.searchsel_city3.value = element.defalutLocation.split('_')[2]
									}
								} else {
									this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
									this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
								}
							}
							if (element.type === 10) {
								element.value = ''
								element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
								element.nowRadioValue = ''
								element.etc = ''
							} else if (element.type === 11) {
								element.category_details.forEach(detail => {
									if (!element.items) {
										element.items = []
									}
									element.items.push({
										value: '',
										label: detail.detailname,
										color: '',
										class: '',
										errorMessage: '',
										hideDetail: true,
										detailcode: detail.detailcode,
									})
								})
							} else if (element.type === 12) {
								element.items = {
									label: '',
									value: '',
									errorMessage: '',
									hideDetail: true,
									outlined: true,
									color: this.$store.state.PointColor7,
								}
							} else if (element.type === 20) {
								element.items = {
									value: '',
									maxlength: '255',
									outlined: true,
									autofocus: false,
									hideDetail: false,
									errorMessage: '',
									color: this.$store.state.PointColor7,
								}
							}
						})
					} else {
						// this.noInputBox = true
						this.alertModal2.text = '연결된 설문 정보가 없습니다. 등록고객 관리에서 설문정보를 등록해주세요.'
						this.alertModal2.dialog = true
						this.btnDisabled = true
						this.placeTitle = res.data.reservedays[0].title
					}
					this.$store.commit('reservedayInputBox', res.data.reservedays[0].input_box)
					this.$store.commit('maxcount', res.data.reservedays[0].maxcount)
					this.$store.commit('nodaySetting', res.data.reservedays[0].nodaySetting)
					this.$store.commit('timeRange', res.data.reservedays[0].timeRange)
					this.$store.commit('startDate', res.data.reservedays[0].sdate)
					this.$store.commit('endDate', res.data.reservedays[0].edate)
					this.getLength()
				})
				.catch(() => {})
		},

		reserveusers() {
			this.$store.state.loading = false
			if (this.reservedaysData.input_box !== null) {
				this.reserveDialog.title = this.reservedaysData.input_box.name
			}
			console.log(this.reservedaysData)
			this.startDialog.dialog = false
			this.reserveDialog.dialog = true
		},
		nextStep() {
			// this.$store.state.loading = true
			if (this.startDialog.nametxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.startDialog.numtxtField.value === '') {
				this.alertModal.text = '이름과 전화번호를 입력해 주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.startDialog.numtxtField.value.length < 7) {
				this.alertModal.text = '휴대전화번호를 정확히 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			this.reserveDialog.inputUserData = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.reserveusers()
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		change() {
			return {}
		},
		disableNext() {
			if (this.startDialog.numtxtField.value && this.startDialog.nametxtField.value) {
				this.nextbtn.disabled = false
			} else {
				this.nextbtn.disabled = true
			}
			this.reserveDialog.name = this.startDialog.nametxtField.value
		},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		startSurvey() {
			if (
				this.$moment(
					this.$moment()
						.subtract('d', 1)
						.format('YYYY-MM-DD'),
				).isBetween(
					this.$moment()
						.subtract('d', 1)
						.format('YYYY-MM-DD'),
					this.reservedaysData.edate.substring(0, 10),
					undefined,
					'[]',
				)
			) {
				this.startDialog.dialog = true
			} else {
				this.alertModal2.text = '본 상담신청 서비스는 종료되었습니다.'
				this.alertModal2.dialog = true
			}
		},
		checkPopulation() {
			const data = {
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
				inputBoxId: this.reservedaysData.population,
			}
			this.$store
				.dispatch('findReserveusers', data)
				.then(res => {
					if (res.data.reserveusers.length === 0) {
						this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
						return (this.alertModal.dialog = true)
					} else {
						this.reserveusers()
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.reservedaysData.accessPhones
				//
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
	},
}
</script>

<style lang="scss">
.reserve-background-width {
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
</style>
<style lang="scss" scoped>
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
</style>
